<template>
  <div
    v-if="assetAssociations.length > 0"
    class="asset-associations-list-container"
  >
    <div class="title">
      Additional Content
    </div>
    <div
      v-for="assetAssociation in assetAssociations"
      :key="assetAssociation.id"
      class="asset-associations-list-row"
      @click="triggerAssetAssociationAction(assetAssociation)"
    >
      <div
        v-if="assetTitle(assetAssociation)"
        class="asset-title"
      >
        {{ assetTitle(assetAssociation) }}
      </div>
      <div class="asset-type">
        {{ assetType(assetAssociation) }}
      </div>
    </div>
    <asset-association-modal
      v-if="currentAssetAssociation"
      :asset-association="currentAssetAssociation"
      @close-button-clicked="closeModal"
    />
  </div>
</template>

<script>
import AssetAssociationModal from '@components/assetAssociations/modal';

export default {
  components: { AssetAssociationModal },
  props: {
    asset: {
      type: Object,
    },
    context: {
      type: String,
    },
  },
  emits: ['flashcard-aa-clicked'],
  data() {
    return {
      currentAssetAssociation: undefined,
    };
  },
  computed: {
    assetAssociations() {
      if( !this.asset || !this.asset.assetAssociations) { return []; }
      // We need to filter out unsupported asset associations
      const supportedAssociations = ['Topic', 'Attachment', 'Grouping'];
      const exhibitsEnabled = (this.$store.getters['productVars/get']['flashcards_disable_exhibit_ids'] || {}).value === 'true';

      const associations = this.asset.assetAssociations.filter(a => {
        const supported = a.assetAContext === this.context && supportedAssociations.includes(a.assetBType) && a.displayType !== 'embed_before' && a.displayType !== 'scenario_box';
        // special case for groupings, we only support certain types
        if (supported && a.assetBType === 'Grouping') {
          const grouping = this.$store.getters['groupings/all'][a.assetBId];
          // exhibits currently must be supported via product var
          return grouping && grouping.groupingType === 'Exhibit' && exhibitsEnabled;
        }

        return supported;
      });

      return associations.sort((a, b) => a.order - b.order);
    },
  },
  methods: {
    assetTitle(assetAssociation) {
      let assets;
      if( assetAssociation.assetBType.toLowerCase() == 'grouping' ) {
        assets = this.$store.getters['groupings/allArray'];
      } else {
        assets = this.$store.getters[`${assetAssociation.assetBType.toLowerCase()}s/all`];
      }
      const asset = assets?.find(a => a.id === assetAssociation.assetBId);

      return asset?.title || asset?.name || assetAssociation.buttonText || null;
    },
    assetType(assetAssociation) {
      return assetAssociation.assetBType;
    },
    closeModal() {
      this.currentAssetAssociation = undefined;
    },
    triggerAssetAssociationAction(assetAssociation) {
      this[`trigger${assetAssociation.assetBType}Action`](assetAssociation);
    },
    triggerAttachmentAction(assetAssociation) {
      this.currentAssetAssociation = assetAssociation;
    },
    triggerGroupingAction(assetAssociation) {
      this.currentAssetAssociation = assetAssociation;
    },
    triggerTopicAction(assetAssociation) {
      this.currentAssetAssociation = assetAssociation;
    },
    triggerV3FlashcardAction(assetAssociation) {
      this.$emit('flashcard-aa-clicked', assetAssociation.id);
    },
  },
};
</script>

<style lang='scss' scoped>
.asset-associations-list-container {
  background: #f2f4f7;
  padding: rem-calc(12);
  margin: rem-calc(20) 0;
  border-radius: 8px;
}
.asset-associations-list-row:hover {
  background: #e6e9ed;
}
.asset-associations-list-row {
  padding: 16px;
  border-bottom: 1px solid #E9E9E9;
  border-top: 1px solid #E9E9E9;
  cursor: pointer;
}
.asset-title {
  font-size: 15pt;
}
.asset-type {
  color: #727272;
  font-size: 12pt;
}
.title {
  color: #000000;
  font-size: rem-calc(20);
  font-weight: $bold;
  margin-bottom: rem-calc(8);
}
</style>
